"use client";

import React, { useState, useEffect } from "react";
import { Clock, Globe, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
export default function GlobalAvailability() {
  const [time, setTime] = useState<Date | null>(null);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    setTime(new Date());
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formattedTime = time?.toLocaleTimeString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
  return <section data-section-id="228590" id="localização" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-default font-bold mb-4 tracking-tight text-foreground">
            No coração de São Paulo: Pinheiros & Faria Lima
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg">
            Estrategicamente posicionados no polo criativo e tecnológico da capital, 
            oferecemos um ambiente de alta performance para transformar sua visão digital.
          </p>
        </div>

        <Card className="relative overflow-hidden border-border bg-card shadow-xl rounded-xl">
          {}
          <div className="absolute inset-0 pointer-events-none opacity-100 flex items-center justify-center overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/grayscale_sao_paulo_map.png" alt="Mapa de São Paulo" className="w-full h-full object-cover min-w-[800px] grayscale" />
            {}
            <div className="absolute top-[45%] left-[48%] w-4 h-4 bg-primary rounded-full shadow-[0_0_20px_4px_var(--color-primary)] animate-pulse" />
          </div>

          <CardContent className="relative z-10 p-8 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8 items-center">
            {}
            <div className="flex flex-col items-center md:items-start space-y-6">
              <div className="flex items-center space-x-3 text-muted-foreground">
                <div className="p-2 bg-secondary rounded-md">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <span className="font-default font-medium tracking-widest uppercase text-[14px]">
                  HORÁRIO DE BRASÍLIA
                </span>
              </div>
              
              <div className="text-5xl md:text-7xl font-mono font-bold text-foreground tracking-tighter tabular-nums drop-shadow-sm">
                {mounted && formattedTime ? formattedTime : <span className="opacity-0">00:00:00</span>}
              </div>
              
              <div className="flex items-center space-x-2 text-lg text-muted-foreground font-mono bg-background/80 backdrop-blur-sm px-4 py-1.5 rounded-full border border-border">
                <Globe className="w-4 h-4" />
                <span className="uppercase text-[14px] tracking-widest">SÃO PAULO, SP</span>
              </div>
            </div>

            {}
            <div className="h-px w-full bg-border md:hidden" />

            {}
            <div className="flex flex-col items-center md:items-start space-y-6 md:pl-12 md:border-l border-border">
              <div className="flex items-center space-x-3 text-muted-foreground">
                <div className="p-2 bg-secondary rounded-md">
                  <Zap className="w-5 h-5 text-primary" />
                </div>
                <span className="font-default font-medium tracking-widest uppercase text-[14px]">
                  PROXIMIDADE
                </span>
              </div>
              
              <div className="text-3xl md:text-4xl font-default font-semibold text-foreground">
                Pinheiros
              </div>
              
              <Badge variant="default" className="text-lg py-1.5 px-5 bg-primary text-primary-foreground shadow-md">
                Eixo Faria Lima
              </Badge>
              
              <p className="text-sm text-muted-foreground text-center md:text-left max-w-xs leading-relaxed">
                Localização privilegiada para reuniões presenciais e workshops estratégicos. Atendimento de Segunda a Sexta, das 9h às 18h.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}